/*
  mob_cat_list
*/
/**
 * Mobile CATEGORIE LIST script
 */
//== get elements 
var cat_list_trigger = "[class^=mob_cat_list] .cat-list > li > a";
var cat_lists = "[class^=mob_cat_list] .cat-list > li";

//== on trigger click
$(document.body).on("click", cat_list_trigger, function() {

    
    var this_h = $(this).height(); // get base dropdown height //
    var li_el = $(this).parent(); // get dropdown element //
    $(cat_list_trigger).not($(this)).removeClass("open"); // clear open dropdowns //
    $(cat_lists).css("height", this_h); // clean open dropdowns //
    $(this).toggleClass("open"); // toggle open class //
    

    if ($(this).hasClass("open")) { //open submenu

        var ul_h = li_el.find("ul.sub-cat").height();
        var new_h = this_h + ul_h;
        li_el.css("height", new_h+"px");
    }
    else {
        li_el.css("height", this_h); //close submenu
    }
});
